import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function EmotionalSection() {
  return <section className="py-5 relative overflow-hidden bg-[#FFFFFF]" data-id="element-49">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(circle at center, rgba(201,150,59,0.06) 0%, transparent 70%)'
    }} data-id="element-50" />
      <div className="container mx-auto px-4 relative z-10" data-id="element-51">
        <div className="max-w-2xl mx-auto text-center" data-id="element-52">
          <FadeIn data-id="element-53">
            <h2 className="text-2xl md:text-3xl font-bold mb-2 leading-snug" style={{
            color: 'var(--color-deep-blue)'
          }} data-id="element-54">
              Una forma amorosa de sembrar fe desde pequeños
            </h2>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-55">
            <p className="text-base md:text-lg leading-relaxed" style={{
            color: 'var(--color-body)'
          }} data-id="element-56">
              Esta colección, con sus 500 parábolas, devocionales y actividades,
              fue creada para acompañar a los niños en sus primeros pasos de fe
              con materiales simples, tiernos y listos para usar. Porque cada
              historia compartida, cada pregunta y cada momento alrededor de la
              Palabra de Dios es una semilla que queda en el corazón.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}